
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  props: {
    classes: { type: String }
  }
}
